import { RouteConfig } from "vue-router";
import { Permission } from "@/utils/permissions";

const salesRouter: Array<RouteConfig> = [
  {
    path: "sales_list",
    name: "sales_list",
    component: () => import("@/views/Sales/SalesList.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_ADMIN]
    }
  },
  {
    path: "sales_list/new_account",
    name: "new_sale",
    component: () => import("@/views/Sales/NewSale.vue"),
    meta: {
      permissionsRequired: [Permission.ADD_ADMIN]
    }
  }
];

export default salesRouter;
